import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  users: [],
  userPagination: null,
});

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      const sanitizedUsers = action.payload.map((user) => ({
        ...user,
        last_name: user.last_name ?? '',
      }));
      localStorage.setItem(`users`, JSON.stringify(action.payload));
      state.users = sanitizedUsers;
    },
    setUsersPagination: (state, action) => {
      localStorage.setItem('userPagination', JSON.stringify(action.payload));
      state.userPagination = action.payload;
    },
  },
});

export const { setUsers, setUsersPagination } = usersSlice.actions;

export default usersSlice.reducer;
